import { computed, reactive } from '@nuxtjs/composition-api';

interface UiNotification {
  message: string;
  action: { text: string; onClick: (...args: any) => void };
  type: 'danger' | 'success' | 'info';
  icon: string;
  persist: boolean;
  id: symbol;
  dismiss: () => void;
  time: number;
}

interface Notifications {
  notifications: Array<UiNotification>;
}

const state = reactive<Notifications>({
  notifications: []
});
const maxVisibleNotifications = 3;
const timeToLive = 3000;

const useUiNotification = (): any => {
  const send = (notification: UiNotification) => {
    const id = Symbol();

    const dismiss = () => {
      const index = state.notifications.findIndex(notification => notification.id === id);

      if (index !== -1) state.notifications.splice(index, 1);
    };

    const newNotification = {
      ...notification,
      id,
      dismiss
    };

    state.notifications.push(newNotification);
    if (state.notifications.length > maxVisibleNotifications) state.notifications.shift();
    const time = notification.time || timeToLive;
    if (!notification.persist) {
      setTimeout(dismiss, time);
    }
    return id;
  };
  const dismiss = async (id:any) => {
    const index = state.notifications.findIndex(notification => notification.id === id);
    if (index !== -1) state.notifications.splice(index, 1);
    return index !== -1;
  };
  const allDismiss = () => {
    state.notifications = [];
  };
  return {
    send,
    dismiss,
    notifications: computed(() => state.notifications),
    allDismiss
  };
};

export default useUiNotification;
